import { catchError, of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';
import { AddressModel } from '@/models';

export default class CheckoutService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN);
  static userUrl = getApiUrl(API_URL.USER);

  getShippingModeForStoreId(storeId: string) {
    return this.api.getJSON(`${CheckoutService.baseUrl}/shipping/byStoreId?storeId=${storeId}`).pipe(
      catchError(() => of([]))
    );
  }

  getShippingModeForCartId(cartId: string) {
    return this.api.getJSON(`${CheckoutService.baseUrl}/shipping/cart?cartId=${cartId}`).pipe(
      catchError(() => of([]))
    );
  }

  getShippingModeForCart(storeId: string) {
    return this.api.getJSON(`${CheckoutService.userUrl}/cart/${storeId}/getShippings`, {}).pipe(
      catchError(() => of([]))
    );
  }

  getPayments(storeId: string) {
    return this.api.getJSON(`${CheckoutService.baseUrl}/payment/byStoreId?storeId=${storeId}`).pipe(
      catchError(() => of([]))
    );
  }

  getFedexForZipcode(cp: string, { storeId }: { storeId: string }) {
    return this.api.getJSON(`${CheckoutService.userUrl}/cart/${storeId}/fedexsimulator/${cp}`);
  }

  checkCartStorageCompatibility(storeId) {
    return this.api.getJSON(`${CheckoutService.userUrl}/cart/${storeId}/checkCartStorageCompatibility`);
  }

  getShippingForApplePay({ storeId, country, postalCode }: { storeId: string, country?: string, postalCode?: string }) {
    const requestUrl = `${CheckoutService.userUrl}/cart/${storeId}/getShippingForApplePay`;
    let paramUrl = '';

    if (country && postalCode) {
      paramUrl = `?country=${country}&postalCode=${postalCode}`;
    }

    return this.api.getJSON(`${requestUrl}${paramUrl}`).pipe(catchError(() => of([])));
  }
}
